import React, {createRef, useState, useContext, useEffect} from 'react';
import {useAuth0} from "@auth0/auth0-react";
import MaterialTable from "@material-table/core";
import { defaultComponents, MaterialTableBody, MaterialTableBodyRow } from '../../../controls/Material-Table-Components';
import SystemContext from "../../../SystemContext";
import {ColumnWidth, ValidatorColumn} from "../../../blocks/ColumnHelper";
import {isHTML} from "../../../functions/TemplateHelperFunctions";
import {LabelledPaper} from "../../../controls";
import {FormControl, FormGroup, TextField, useTheme} from "@material-ui/core";
import StringToJSX from "../../../functions/StringToJsx";

const defaultLabelledPaperProps = {
  checkChildren: true,
  style: {display: "block", border: "solid 1px #b9b9b9" },
  labelStyle: {background: "#f0f0f0"},
  collapsible: false,
}

const FlightMessageContent = (_props) => {
  const SystemData = useContext(SystemContext);
  const theme = useTheme();
  const {isAuthenticated} = useAuth0();
  const eventBus = SystemData.eventBus;

  const props = {
    ..._props
  }
  const {classes} = props;

  const [state, setState] = useState({
    canEdit: props.canEdit,
    messages: []
  });

  const tableRef = createRef({state: {lastEditingRow: false}});

  if (eventBus) {
    eventBus.bind('DeadLoad.AddFunction', ()=> {
      if (tableRef  && tableRef.current) {
        tableRef.current.dataManager.changeRowEditing();
        tableRef.current.setState({
          ...tableRef.current.dataManager.getRenderState(),
          showAddRow: !tableRef.current.state.showAddRow,
        });
      }
    });
  }

  useEffect(()=> {
    const display = async (messages) => {
      setState({...state, messages: messages });
    }

    eventBus.bind("FlightMessageContent.rowSelected", display);

    return () => {
      eventBus.unbind("FlightMessageContent.rowSelected", display);
    }
  }, [state, eventBus]);


  const messages = state.messages;

  const getColumns = (props) => {
    const baseColumn = {
      cellStyle: { padding: "8px 2px" },
      headerStyle: { padding: "8px 2px" },
      editable: state.canEdit?"always":"never",
      emptyValue: "",
      initialEditValue: "",
      sorting: false
    };
    const defaultEditProps = {
      style:{fontSize: "0.875rem"}
    };


    return [
      {
        ...baseColumn,
        ...ColumnWidth(710,[5,2],undefined,undefined,undefined,undefined,false),
        title: "Message Content",
        field: "messageContent",
        render: (record) => {
          // eslint-disable-next-line no-lone-blocks
          {return (isHTML(record.messageContent)
              ?
              <LabelledPaper {...defaultLabelledPaperProps} label={`Message Body`} >
                <FormControl checkChildren={true} key="FC-slotmessage" style={{display: "block" }}>
                  <FormGroup checkChildren={true} key="FG-slotmessage" style={{padding: "8px 8px 8px 8px"}}>
                    <div style={{width: "100%", minHeight: 300, maxHeight: 600, overflowY: "scroll"}}>
                      <StringToJSX domString={record.messageContent}/>
                    </div>
                  </FormGroup>
                </FormControl>
              </LabelledPaper>
              :
              <TextField
                id="messageContent"
                value={record.messageContent}
                // label={"Message"}
                // InputLabelProps={{ shrink: true }}
                style={{width: "100%"}}
                multiline
                // minRows={1}
                // maxRows={12}
                inputProps={{readOnly:true, style:{height: "calc(100vh - 390px)", overflowY: "scroll", overflow: "hidden scroll", fontFamily: "monospace"  }}}
                InputProps={{disableUnderline: true }}
                // variant={"outlined"}
                onChange={(value, props) => {
                  let updatedMessage = "";
                  if (value && value.length > 0) {
                    updatedMessage = value;
                  }
                  props.recordChange({...props.record, textBody: updatedMessage, originalMessage: props?.record?.messageContent});
                }}
              />
          )}
        }
      },
    ];
  };


  const bodyRef = createRef();

  return (isAuthenticated &&
        <div className={classes.TripLegEditor} style={{width: "100%", overflow: "scroll", maxHeight: 700}}>
          <MaterialTable
            tableRef={tableRef}
            data={messages}
            style={{
              backgroundColor: "#fdfdfd",
              boxShadow: "none",
              border: "2px solid #aaaaaa",
              borderRadius: 0,
            }}
            options={{
              actionsColumnIndex: -1,
              search: false,
              cellStyle: {
                padding: "8px 2px",
              },
              headerStyle: {
                backgroundColor: theme.palette.childTableHeader.backgroundColor,
                color: theme.palette.childTableHeader.textColor,
                padding: "2px",
              },
              toolbarButtonAlignment: "right",
              detailPanelType: "single",
              showTitle: false,
              toolbar: false,
              padding: 'dense',
              paging: false,
              filtering: false,
              draggable: false,
              grouping: false
            }}
            components={{
              ...defaultComponents,
              Body: (props) => (
                <MaterialTableBody
                  {...props}
                  ref={bodyRef}
                  rowHeight={46}
                  overscanRowCount={99999}
                  addVirtualScrolling={true}
                  bodyHeight={600}
                  headerHeight={46}
                />
              ),
              Row: (props) => (
                <MaterialTableBodyRow
                  {...props}
                />
              ),
            }}
            title="Message Content"
            localization={{
              body: {
                emptyDataSourceMessage: 'Select a message to display its content'
              },
            }}
            columns={getColumns({...props, canEdit: state.canEdit})}
            editable={{
              isEditable: false,
              isDeletable: false,
              onRowAdd: undefined,
              onRowUpdate: undefined,
              onRowDelete: undefined,
            }}
        />
      </div>
  );
}

export default FlightMessageContent;
